// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zoomIn[data-v-5271b31a] {\n  -webkit-animation: zoomIn 0.5s;\n          animation: zoomIn 0.5s;\n}", ""]);
// Exports
module.exports = exports;
